import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import { useState } from "react";
import RatingModal from "../../Modals/rating";
import { Button } from "@mui/material";
import useTranslation from "../../hooks/traslation";
import moment from "moment";
import { RefundData } from "../../types/General";
import ManageOffers from "../../pages/manageRefund/offers";

interface CustomerCompletedIssuesProps {
  rows: RefundData[];
  page: number;
  handleChange: (event: any, newPage: number) => void;
  loading: boolean;
  count: number;
}

const CustomerCompletedIssues = ({
  rows,
  page,
  handleChange,
  loading,
  count,
}: CustomerCompletedIssuesProps) => {
  const navigate = useNavigate();
  const translation = useTranslation();

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 200,
      field: "employerId",
      headerName: translation.main.employerDetail,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            className="user_block click_action"
            onClick={() =>
              navigate(
                `/manage-employers/detail/${params?.row?.employerId?._id}`
              )
            }
          >
            <figure>
              <img
                src={
                  params?.row?.employerId?.image ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>{`${params?.row?.employerId?.firstName} ${params?.row?.employerId?.lastName}`}</b>
              <span>{params?.row?.employerId?.email}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "freelancerId",
      headerName: translation.main.freelancerDetail,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            className="user_block click_action"
            onClick={() =>
              navigate(
                `/manage-freelancer/detail/${params?.row?.freelancerId?._id}`
              )
            }
          >
            <figure>
              <img
                src={
                  params?.row?.freelancerId?.image ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>{`${params?.row?.freelancerId?.firstName} ${params?.row?.freelancerId?.lastName}`}</b>
              <span>{params?.row?.freelancerId?.email}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 250,
      field: "categoryId",
      headerName: "Category",
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="user_block">
            <p>{params?.row.categoryId.name}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 200,
      field: "subCategoryId",
      headerName: "Sub Service",
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return params.row.subCategoryId.name;
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "createdAt",
      headerName: translation.main.dateTime,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return moment(params.row.createdAt).format("DD MMMM YYYY, hh:mm A");
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "bookingId",
      headerName: translation.main.Amount,
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <p className="c_success">
            <strong>AED {params.row.bookingId.total}</strong>
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "offers",
      headerName: translation.user.Actions,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        return (
          <Button
            className="btn sm btn_primary"
            onClick={() =>
              navigate(
                `/manage-dispute-refunds/offers/${
                  params?.row?.bookingId?._id
                }/${params?.row?.status ? params?.row?.status : 1}`
              )
            }
          >
            {translation.globals.View}
          </Button>
        );
      },
    },
  ];

  let hidden = ["fullName"];

  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
          loading={loading}
          count={count}
          page={page}
          onPageChange={handleChange}
        />
      </div>

      <RatingModal open={open} onClose={handleCloseModal} setOpen={setOpen} />
    </>
  );
};

export default CustomerCompletedIssues;
